export default __webpack_public_path__ + "static/media/place_holder_Country.8b166f2e.svg";